export default __webpack_public_path__ + "static/media/favicon.e511d2e6.svg";